import { useRoutes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ClienteAuthProvider } from './contexts/ClienteAuthContext';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { PedidosPage } from './pages/PedidosPage';
import { NovoPedidoPage } from './pages/NovoPedidoPage';
import { ClientesPage } from './pages/ClientesPage';
import { CosturaPage } from './pages/CosturaPage';
import { FinanceiroPage } from './pages/FinanceiroPage';
import { EntradaRapidaPage } from './pages/EntradaRapidaPage';
import { CatalogoPage } from './pages/CatalogoPage';
import { ItensPadraoPage } from './pages/ItensPadraoPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ProtectedContaRoute } from './components/ProtectedContaRoute';
import { CarrinhoProvider } from './pages/loja/carrinho';
import { LojaPage } from './pages/loja/LojaPage';
import { CheckoutPage } from './pages/loja/CheckoutPage';
import { PedidoStatusPage } from './pages/loja/PedidoStatusPage';
import { ContaLoginPage } from './pages/conta/ContaLoginPage';
import { ContaLayout } from './pages/conta/ContaLayout';
import { ContaPainelPage } from './pages/conta/ContaPainelPage';
import { ContaPedidosPage } from './pages/conta/ContaPedidosPage';
import { ContaSegurancaPage } from './pages/conta/ContaSegurancaPage';

function AppRoutes() {
  return useRoutes([
    // Loja virtual (público)
    { path: '/loja', element: <CarrinhoProvider><LojaPage /></CarrinhoProvider> },
    { path: '/loja/checkout', element: <CarrinhoProvider><CheckoutPage /></CarrinhoProvider> },
    { path: '/loja/pedido/:id', element: <PedidoStatusPage /> },

    // Área do cliente da loja ("Minha conta")
    { path: '/loja/conta/login', element: <ContaLoginPage /> },
    {
      path: '/loja/conta',
      element: <ProtectedContaRoute><ContaLayout /></ProtectedContaRoute>,
      children: [
        { path: '', element: <ContaPainelPage /> },
        { path: 'pedidos', element: <ContaPedidosPage /> },
        { path: 'seguranca', element: <ContaSegurancaPage /> },
      ],
    },

    // Painel administrativo
    { path: '/login', element: <LoginPage /> },
    {
      path: '/',
      element: <ProtectedRoute><Layout /></ProtectedRoute>,
      children: [
        { path: '/', element: <DashboardPage /> },
        { path: '/pedidos', element: <PedidosPage /> },
        { path: '/pedidos/novo', element: <NovoPedidoPage /> },
        { path: '/clientes', element: <ClientesPage /> },
        { path: '/costura', element: <CosturaPage /> },
        { path: '/financeiro', element: <FinanceiroPage /> },
        { path: '/entrada-rapida', element: <EntradaRapidaPage /> },
        { path: '/catalogo', element: <CatalogoPage /> },
        { path: '/itens-padrao', element: <ItensPadraoPage /> },
      ],
    },
  ]);
}

function App() {
  return (
    <AuthProvider>
      <ClienteAuthProvider>
        <AppRoutes />
      </ClienteAuthProvider>
    </AuthProvider>
  );
}

export default App;
